import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '../services';
import { notifyAccessDenied } from './notify-access-denied';

export const adminAuthorizationGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const currentUser: CurrentUserService = inject(CurrentUserService);

  if (currentUser.currentUserInfo()?.isAdmin) {
    return true;
  }

  notifyAccessDenied();
  return router.createUrlTree([currentUser.defaultAuthenticatedRoute()]);
};
